var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-news",style:({
    opacity:
      (_vm.getIsDeletingNews(_vm.item.id) && _vm.location === `news`) ||
      (_vm.getIsDeletingCourses(_vm.item.id) && _vm.location === `courses`)
        ? 0.5
        : 1
  })},[(_vm.item.date)?_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(new Date(_vm.item.date).toLocaleDateString())+" ")]):_vm._e(),_c('div',{staticClass:"element-title"},[_vm._v(_vm._s(_vm.item.title))]),(
      (_vm.getIsUpdatingNews(_vm.item.id) && _vm.location === `news`) ||
        (_vm.getIsUpdatingCourses(_vm.item.id) && _vm.location === `courses`)
    )?_c('div',{staticClass:"updating",style:({
      backgroundImage: `url(${require('./../../assets/loader.gif')})`
    })}):_c('div',{staticClass:"icon"},[_c('button',{attrs:{"id":"pen","disabled":(_vm.getIsDeletingNews(_vm.item.id) && _vm.location === `news`) ||
          (_vm.getIsDeletingCourses(_vm.item.id) && _vm.location === `courses`)},on:{"click":_vm.editItem}},[_c('i',{staticClass:"fas fa-pen"})]),_c('button',{attrs:{"id":"tresh","disabled":(_vm.getIsDeletingNews(_vm.item.id) && _vm.location === `news`) ||
          (_vm.getIsDeletingCourses(_vm.item.id) && _vm.location === `courses`)},on:{"click":() => _vm.deleteItem(_vm.item)}},[_c('i',{staticClass:"fas fa-trash-alt"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }